import clsx from "clsx";
import { useMemo } from "react";
import { BackIcon, ShareIcon, BookIcon, CloseIcon, CustomerIcon, BookV2Icon } from "@/components/RFIcon";
import { useRouter } from "next/router";
import { BridgeCallHandlers } from "@/interfaces/enums";
import bridge from "@/utils/dsBridge";
import React from "react";

export interface Props {
	onClick?: () => void;
	space?: "leading" | "trailing";
	style?: React.CSSProperties;
	strokeWidth?: number;
}
// 返回按钮
export function BackUseIcon(props: Props & { backType?: "close" | "back" }) {
	const router = useRouter();
	const memoizedSpace = useMemo(() => {
		switch (props.space) {
			case "leading":
				return "ml-4";
			case "trailing":
				return "mr-4";
			default:
				return "";
		}
	}, [props.space]);

	const handleClick = () => {
		if (props.onClick) return props.onClick();

		if (props.backType === "close") {
			bridge.call(BridgeCallHandlers.ON_CLOSE_WEB_PAGE);
			return;
		}
		if (props.backType === "back") {
			router.back();
			return;
		}

		if (props.backType === "back" && router.query.visible) {
			bridge.call(BridgeCallHandlers.ON_CLOSE_WEB_PAGE);
		} else {
			router.back();
		}
	};

	return (
		<BackIcon onClick={handleClick} className={clsx("cursor-pointer w-[20px] h-[20px] flex-shrink-0", memoizedSpace)} />
	);
}

// 分享按钮
export function ShareUseIcon(props: Props) {
	const memoizedSpace = useMemo(() => {
		switch (props.space) {
			case "leading":
				return "ml-4";
			case "trailing":
				return "mr-4";
			default:
				return "";
		}
	}, [props.space]);
	return (
		<ShareIcon
			onClick={props.onClick}
			className={clsx("cursor-pointer w-[22px] h-[20px] flex-shrink-0", memoizedSpace)}
			style={props.style}
		/>
	);
}

// link 按钮
export function LinkUseIcon(props: Props) {
	const memoizedSpace = useMemo(() => {
		switch (props.space) {
			case "leading":
				return "ml-4";
			case "trailing":
				return "mr-4";
			default:
				return "";
		}
	}, [props.space]);
	return (
		<BookIcon
			onClick={props.onClick}
			className={clsx("cursor-pointer w-[18px] h-[18px] flex-shrink-0", memoizedSpace)}
		/>
	);
}

export function LinkUseIconV2(props: Props) {
	const memoizedSpace = useMemo(() => {
		switch (props.space) {
			case "leading":
				return "ml-4";
			case "trailing":
				return "mr-4";
			default:
				return "";
		}
	}, [props.space]);
	return (
		<BookV2Icon
			onClick={props.onClick}
			className={clsx(" cursor-pointer w-[21px] h-[21px] flex-shrink-0", memoizedSpace)}
		/>
	);
}

// close
export function CloseUseIcon(props: Props) {
	const memoizedSpace = useMemo(() => {
		switch (props.space) {
			case "leading":
				return "ml-4";
			case "trailing":
				return "mr-4";
			default:
				return "";
		}
	}, [props.space]);
	return <CloseIcon onClick={props.onClick} className={clsx("cursor-pointer w-[20px] h-[20px]", memoizedSpace)} />;
}

// 客服
export function CustomerUseIcon(props: Props) {
	const memoizedSpace = useMemo(() => {
		switch (props.space) {
			case "leading":
				return "ml-4";
			case "trailing":
				return "mr-4";
			default:
				return "";
		}
	}, [props.space]);
	return (
		<CustomerIcon
			strokeWidth={props.strokeWidth}
			onClick={props.onClick}
			className={clsx("cursor-pointer w-[20px] h-[20px]", memoizedSpace)}
		/>
	);
}

/**----------------------之后再这里添加------------------------------*/
